import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalAsignacionInicialPageRoutingModule } from './modal-asignacion-inicial-routing.module';
import { IonicSelectableModule } from 'ionic-selectable';

import { ModalAsignacionInicialPage } from './modal-asignacion-inicial.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    IonicSelectableModule,
    ModalAsignacionInicialPageRoutingModule
  ],
  declarations: [ModalAsignacionInicialPage]
})
export class ModalAsignacionInicialPageModule {}
